export const loaderStyles = {
  position: "absolute",
  top: "50%",
  left: "50%",
  zIndex: 100
};